import React from "react";
import SkeletonElement from "./BasicSkeleton/SkeletonElement";
import SkeletonCard from "./BasicSkeleton/SkeletonCard";
import SkeletonAnimation from "./BasicSkeleton/SkeletonAnimation";

const IndividualPageSkeleton = () => {
  return (
    <div className="individual-page-skeleton">
      <div className="d-flex justify-content-between">
        <div className="skeleton-card large back">
          <SkeletonElement type="title" />
          <SkeletonAnimation />
        </div>
        <div className="skeleton-card large share">
          <SkeletonElement type="title" />
          <SkeletonAnimation />
        </div>
      </div>
      <div className="d-flex flex-column flex-lg-row justify-content-between">
        <div className="flex-fill">
          <div className="skeleton-card large image-card">
            <SkeletonElement type="img" />
            <SkeletonAnimation />
            <SkeletonAnimation />
          </div>
          <div className="d-flex justify-content-between ms-3 align-items-center desc class-type">
            <SkeletonElement type="title w-25" />
            <div className="w-50 d-flex">
              <SkeletonElement type="text me-2" />
              <SkeletonElement type="text" />
            </div>
          </div>
          <div className="ms-3 desc">
            <SkeletonElement type="title" />
            <SkeletonElement type="text me-3" />
          </div>

          <div className="mt-5">
            <SkeletonElement type="title ms-3 individual-title" />
            <div className="skeleton-card p-2 large ms-2 mt-3 properties">
              <div className="properties-container">
                <div className="pro-skill">
                  <div className="d-flex align-items-center">
                    <SkeletonElement type="text ms-4" />
                  </div>
                  <div className="d-flex align-items-center w-100">
                    <SkeletonElement type="text w-100 mx-2" />
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex align-items-center">
                    <SkeletonElement type="text  ms-4" />
                  </div>
                  <div className="d-flex align-items-center w-100">
                    <SkeletonElement type="text w-100  mx-2" />
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex align-items-center">
                    <SkeletonElement type="text ms-4" />
                  </div>
                  <div className="d-flex align-items-center w-100">
                    <SkeletonElement type="text w-100  mx-2" />
                  </div>
                </div>
              </div>
              <div className="properties-container mt-2">
                <div className="pro-skill">
                  <div className="d-flex align-items-center">
                    <SkeletonElement type="text ms-4" />
                  </div>
                  <div className="d-flex align-items-center w-100">
                    <SkeletonElement type="text w-100 mx-2" />
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex align-items-center">
                    <SkeletonElement type="text  ms-4" />
                  </div>
                  <div className="d-flex align-items-center w-100">
                    <SkeletonElement type="text w-100  mx-2" />
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex align-items-center">
                    <SkeletonElement type="text ms-4" />
                  </div>
                  <div className="d-flex align-items-center w-100">
                    <SkeletonElement type="text w-100  mx-2" />
                  </div>
                </div>
              </div>
              <SkeletonAnimation />
            </div>
          </div>
        </div>

        <div className="flex-fill">
          <div>
            <SkeletonElement type="title individual-title" />
            <div className="skeleton-card large d-flex justify-content-between flex-column flex-lg-row  ms-0 detail">
              <div>
                <SkeletonElement type="title" />
                <SkeletonElement type="text" />
              </div>
              <div className="d-flex">
                <SkeletonElement type="button" />
                <SkeletonElement type="button ms-2" />
              </div>
              <SkeletonAnimation />
            </div>
          </div>
          <div className="skill">
            <SkeletonElement type="title individual-title" />
            <div className="skeleton-card large ms-0">
              <SkeletonElement type="thumbnail" />
              <SkeletonElement type="text mt-4" />
              <SkeletonAnimation />
            </div>
          </div>
          <div>
            <SkeletonElement type="title individual-title" />
            <div className="skeleton-card large ms-0">
              <div className="skill-container">
                <div className="pro-skill">
                  <div className="d-flex">
                    <SkeletonElement type="svg" />
                    <div className="ms-2">
                      <SkeletonElement type="title " />
                      <SkeletonElement type="text" />
                    </div>
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex">
                    <SkeletonElement type="svg" />
                    <div className="ms-2">
                      <SkeletonElement type="title " />
                      <SkeletonElement type="text" />
                    </div>
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex">
                    <SkeletonElement type="svg" />
                    <div className="ms-2">
                      <SkeletonElement type="title " />
                      <SkeletonElement type="text" />
                    </div>
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex">
                    <SkeletonElement type="svg" />
                    <div className="ms-2">
                      <SkeletonElement type="title " />
                      <SkeletonElement type="text" />
                    </div>
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex">
                    <SkeletonElement type="svg" />
                    <div className="ms-2">
                      <SkeletonElement type="title " />
                      <SkeletonElement type="text" />
                    </div>
                  </div>
                </div>
                <div className="pro-skill">
                  <div className="d-flex">
                    <SkeletonElement type="svg" />
                    <div className="ms-2">
                      <SkeletonElement type="title " />
                      <SkeletonElement type="text" />
                    </div>
                  </div>
                </div>
              </div>
              <SkeletonAnimation />
            </div>
          </div>
          <div>
            <SkeletonElement type="title individual-title" />
            <div className="skeleton-card large ms-0">
              <div className="d-flex justify-content-between text-container">
                <SkeletonElement type="title " />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
              </div>
              <div className="d-flex justify-content-between text-container">
                <SkeletonElement type="title " />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
              </div>
              <div className="d-flex justify-content-between text-container">
                <SkeletonElement type="title " />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
              </div>
              <div className="d-flex justify-content-between text-container">
                <SkeletonElement type="title " />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
                <SkeletonElement type="title" />
              </div>
              <SkeletonAnimation />
            </div>
            <div>
              <SkeletonElement type="title individual-title" />
              <div className="skeleton-card large ms-0">
                <div className="d-flex align-items-center">
                  <div className="me-2">
                    <SkeletonElement type="text" />
                    <SkeletonElement type="title" />
                  </div>
                  <SkeletonElement type="text w-50" />
                </div>
                <div className="d-flex align-items-center">
                  <div className="me-2">
                    <SkeletonElement type="text" />
                    <SkeletonElement type="title" />
                  </div>
                  <SkeletonElement type="text w-50" />
                </div>
                <div className="d-flex align-items-center">
                  <div className="me-2">
                    <SkeletonElement type="text" />
                    <SkeletonElement type="title " />
                  </div>
                  <SkeletonElement type="text  w-50" />
                </div>
                <SkeletonAnimation />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualPageSkeleton;
